





























































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CustomTable from "@/components/form/CustomTable.vue";
import StudentListItem from "@/components/students/StudentListItem.vue";
import {
  Student as IStudent,
  StudentList as IStudentList
} from "@/api-v2/course/models";
import students, { StudentsListParams } from "@/getinfo-api/students";
import studentRegistrationAvailable from "@/getinfo-api/courseAvailableStudents";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import { courseApi } from "@/getinfo-api";
import Modal from "@/components/form/Modal.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { StudentSort, SortFields } from "@/plugins/sort-fields";
import { getCurrentCompanyId } from "@/plugins/roles";

import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CField from "@/components/form/CField.vue";
import { debounce } from "lodash";

@Component({
  components: {
    CField,
    CustomDatepicker,
    CustomButton,
    Modal,
    StudentListItem,
    CustomTable
  }
})
export default class StudentTable extends Vue {
  @Prop() formProp!: StudentsListParams;
  @Prop() courseId!: string;
  @Prop() studentsProp!: IStudent[];
  @Prop({ default: false }) isLocal!: boolean;
  @Prop({ default: false }) courseAvailableStudents!: boolean;
  @Prop({ default: true }) isShowAction!: boolean;
  @Prop() value!: IStudent[];
  @Prop({ default: () => [] }) disableFields!: string[];
  @Prop({ default: true }) selectable!: boolean;
  @Prop({ default: false }) isNeedFilter!: boolean;
  students!: IStudentList;
  isLoading: boolean = false;
  checkedStudents: IStudent[] = [];
  checkedAll: boolean = false;
  indeterminate: boolean = false;
  pageNumber: number = 1;
  sorted: SortFields<StudentSort> = new SortFields(StudentSort.createdAt);

  userRegisteredAtMin!: Date | undefined;
  userRegisteredAtMax!: Date | undefined;
  searchListenerByEmail!: string;

  form: any = {
    name: this.searchListenerByEmail,
    sort: this.sorted.sort,
    order: this.sorted.order,
    createdAtMin: this.userRegisteredAtMin,
    createdAtMax: this.userRegisteredAtMax,
    companyId: this.currentCompany,
    offset: 0,
    limit: 30
  };

  data() {
    return {
      searchListenerByEmail: undefined,
      userRegisteredAtMin: undefined,
      userRegisteredAtMax: undefined,
      students: undefined,
      userId: undefined
    };
  }

  get sortStatus() {
    return StudentSort;
  }

  studentRemove(id: string) {
    this.students.items = this.students.items.filter(el => el.id !== id);
    this.students.count--;
  }

  clearFilter() {
    this.form.createdAtMax = undefined;
    this.form.createdAtMin = undefined;
    this.form.name = "";
    this.getStudents();
  }

  getCheckedStudent(student: IStudent) {
    if (!this.checkedStudents.some(el => el.id === student.id)) {
      this.checkedStudents.push(student);
      this.$emit("check", this.checkedStudents);
    } else {
      this.checkedStudents = this.checkedStudents.filter(
        el => el.id !== student.id
      );
    }
  }

  get currentCompany() {
    return getCurrentCompanyId();
  }

  acceptSort(sort: StudentSort) {
    if (!this.isLocal) {
      this.sorted.changeSort(sort);
      this.form.offset = 0;
      this.pageNumber = 1;
      this.form.sort = this.sorted.sort;
      this.form.order = this.sorted.order;
      this.currentFetchMethod();
    }
  }

  async removeStudents() {
    const removeList = this.checkedStudents.map(el => el.id);
    this.isLoading = true;
    await Promise.allSettled(
      removeList.map(el =>
        courseApi.Student.deleteStudent(el).then(() => {
          this.students.items = this.students.items.filter(
            student => student.id !== el
          );
        })
      )
    ).finally(() => {
      this.checkedStudents = [];
      this.isLoading = false;
    });
  }

  get currentFetchMethod() {
    return this.courseAvailableStudents
      ? this.getNonRegisterStudents
      : this.getStudents;
  }

  debouncedGetStudents = debounce(this.getStudents, 300);

  onInputChanged() {
    this.debouncedGetStudents();
  }

  getStudents() {
    this.isLoading = true;
    students(this.form)
      .then(res => {
        this.students = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  getNonRegisterStudents() {
    this.isLoading = true;
    this.form.courseId = this.courseId;

    studentRegistrationAvailable(this.form)
      .then(res => {
        this.students = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })

      .finally(() => {
        this.isLoading = false;
      });
  }

  @Watch("value")
  checkPropValue() {
    this.checkedStudents = this.value;
  }

  @Watch("formProp", { immediate: true, deep: true })
  checkFormProp() {
    if (this.formProp) {
      this.form = {
        ...this.form,
        ...this.formProp
      };
      this.checkedStudents = [];
      this.checkedAll = false;
      this.currentFetchMethod();
    }
  }

  @Watch("pageNumber")
  onPageChange() {
    this.checkedAll = false;
    this.indeterminate = false;
  }

  @Watch("studentsProp", { immediate: true, deep: true })
  checkStudentsProp() {
    if (this.studentsProp) {
      this.students = {
        items: [],
        count: 0
      };
      this.checkedStudents = [];
      this.students.items = this.studentsProp;
      this.students.count = this.studentsProp.length;
    }
  }

  @Watch("checkedStudents")
  checkSelected(newValue: any) {
    if (newValue.length === 0) {
      this.indeterminate = false;
      this.checkedAll = false;
    } else if (newValue.length === this.students.items.length) {
      this.indeterminate = false;
      this.checkedAll = true;
    } else {
      this.indeterminate = true;
      this.checkedAll = false;
    }
    this.$emit("input", this.checkedStudents);
  }

  checkState(id: string) {
    return this.checkedStudents.some(el => el.id === id);
  }

  isChecked(student: IStudent): boolean {
    return this.checkedStudents.some(
      checkedStudent => checkedStudent.id === student.id
    );
  }

  toggleAll(checked: boolean) {
    if (checked) {
      const currentPageStudents = this.students.items;
      currentPageStudents.forEach(student => {
        if (!this.isChecked(student)) {
          this.checkedStudents.push(student);
        }
      });
    } else {
      const currentPageStudentIds = this.students.items.map(
        student => student.id
      );
      this.checkedStudents = this.checkedStudents.filter(
        student => !currentPageStudentIds.includes(student.id)
      );
    }
  }

  async changePage() {
    await this.$nextTick(() => {
      if (this.form && this.form.limit) {
        this.form.offset = this.form.limit * (this.pageNumber - 1);
        this.currentFetchMethod();
      }
    });
  }

  created() {
    if (!this.isLocal) {
      this.currentFetchMethod();
    }
  }
}
